import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SliceType } from '../types';
import { DebugState } from './types';

const initialState: DebugState = {
  activeWorkflowPrediction: null,
  cursor: null,
  workflowPredictions: [],
};

export default createSlice({
  name: SliceType.XRayDebug,
  initialState,
  selectors: {
    selectActiveWorkflowPrediction: (state) => state.activeWorkflowPrediction,
    selectCursor: (state) => state.cursor,
    selectWorkflowPredictions: (state) => state.workflowPredictions,
  },
  reducers: {
    reset: (state) => {
      state.activeWorkflowPrediction = initialState.activeWorkflowPrediction;
      state.cursor = initialState.cursor;
      state.workflowPredictions = initialState.workflowPredictions;
    },
    setActiveWorkflowPrediction: (
      state,
      action: PayloadAction<DebugState['activeWorkflowPrediction']>,
    ) => {
      state.activeWorkflowPrediction = action.payload;
    },
    setCursor: (state, action: PayloadAction<DebugState['cursor']>) => {
      state.cursor = action.payload;
    },
    setWorkflowPredictions: (
      state,
      action: PayloadAction<DebugState['workflowPredictions']>,
    ) => {
      state.workflowPredictions = action.payload;
    },
  },
});
